import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCaretRight = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	height: "1em",
	width: "1em",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5.5.75,16.22,11.47a.749.749,0,0,1,0,1.06L5.5,23.25",
		fill: "none",
		stroke: "var(--icon-color, currentColor)",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: "var(--icon-stroke-width, 1.5)"
	})
});
export default SvgCaretRight;
